export default function actionLogger(store) {
    let quiz

    const saveLogs = async payload => {
        try {
            await store.dispatch('createQuizLogs', payload)
            return true
        } catch {
            return false
        }
    }

    store.subscribeAction(async (action, state) => {
        switch (action.type) {
            case 'updateQuiz': {
                const logQuiz = JSON.parse(JSON.stringify(quiz))
                const quizData = JSON.parse(JSON.stringify(state.question))

                delete logQuiz.username
                delete quizData.username

                if (JSON.stringify(quizData) === JSON.stringify(logQuiz)) return

                const { title: logTitle, show_school_list: logShowSchoolList, show_school_country_list: logShowCountryList, ...restLogQuiz } = logQuiz
                const { title: quizTitle, show_school_list: quizShowSchoolList, show_school_country_list: quizShowCountryList, ...restQuizData } = quizData

                const updateShareToSchool = () => {
                    quiz.show_school_list = state.question.show_school_list

                    saveLogs({
                        quiz_id: state.question._id,
                        action: 'set_quiz_to_school',
                        payload: {
                            previousStatus: !state.question.show_school_list,
                            newStatus: state.question.show_school_list
                        }
                    })
                }

                const updateShareToCountry = () => {
                    quiz.show_school_country_list = state.question.show_school_country_list

                    saveLogs({
                        quiz_id: state.question._id,
                        action: 'set_quiz_to_country',
                        payload: {
                            previousStatus: !state.question.show_school_country_list,
                            newStatus: state.question.show_school_country_list
                        }
                    })

                }

                if (action.payload && action.payload.saveOnlyShareToSchool) {
                    if (quizShowSchoolList !== logShowSchoolList) {
                        updateShareToSchool()
                    }

                    if (quizShowCountryList !== logShowCountryList) {
                        updateShareToCountry()
                    }

                    return
                }

                const updatePayload = {
                    quiz_id: state.question._id,
                    action: 'update_setting',
                    payload: {}
                }

                if (quizTitle !== logTitle) {
                    updatePayload.payload.updateTitle = {
                        previousTitle: logTitle,
                        newTitle: quizTitle
                    }
                }

                restQuizData.show_number_question = Number(restQuizData.show_number_question)
                restLogQuiz.show_number_question = Number(restLogQuiz.show_number_question)

                const restLogQuizTemp = Object.getOwnPropertyNames(restLogQuiz)

                restLogQuizTemp.splice(
                    restLogQuizTemp.findIndex(e => e === '__ob__'),
                    1
                )

                for (const propName of restLogQuizTemp) {
                    if (!restLogQuiz[propName] && propName == 'background_type') {
                        restLogQuiz[propName] = 'color'
                    }

                    if (!restQuizData[propName] && propName == 'background_type') {
                        restQuizData[propName] = 'color'
                    }

                    if (propName == 'background_music') {
                        if (!restLogQuiz[propName].name) {
                            restLogQuiz[propName].name = 'No Music'
                        }

                        if (!restQuizData[propName].name) {
                            restQuizData[propName].name = 'No Music'
                        }
                    }

                    if (!restLogQuiz[propName] && restLogQuiz[propName] !== false && restLogQuiz[propName] !== 0) {
                        restLogQuiz[propName] = null
                    }

                    if (!restQuizData[propName] && restQuizData[propName] !== false && restQuizData[propName] !== 0) {
                        restQuizData[propName] = null
                    }

                    if (
                        !['tags'].includes(propName) &&
                        JSON.stringify(restLogQuiz[propName]) !== JSON.stringify(restQuizData[propName])
                    ) {
                        updatePayload.payload.isUpdateDetail = true
                        break
                    }
                }

                if (Object.keys(updatePayload.payload).length) {
                    await saveLogs(updatePayload)
                }

                if (quizShowSchoolList !== logShowSchoolList) {
                    updateShareToSchool()
                }


                if (quizShowCountryList !== logShowCountryList) {
                    updateShareToCountry()
                }

                break
            }

            case 'toggleQuizStatus':
                saveLogs({
                    quiz_id: state.question._id,
                    action: 'update_status',
                    payload: {
                        previousStatus: state.question.status,
                        newStatus: !state.question.status
                    }
                })

                break

            case 'updateQuizQuestion':
                if (action.payload.logMessage === 'create/update') {
                    const createPayload = {
                        quiz_id: state.question._id,
                        action: 'create_question',
                        payload: {
                            questions: []
                        }
                    }

                    const updatePayload = {
                        quiz_id: state.question._id,
                        action: 'update_question',
                        payload: {
                            questions: []
                        }
                    }

                    for (const question of action.payload.logQuestions) {
                        const currentQuestion = quiz.questions.find(e => e.uid === question.uid)

                        if (currentQuestion) {
                            if (JSON.stringify(question) !== JSON.stringify(currentQuestion)) {
                                const { title: currentTitle, ...currentWithoutTitle } = currentQuestion
                                const { title: questionTitle, ...questionWithoutTitle } = question

                                const payload = {
                                    title: questionTitle
                                }

                                if (questionTitle !== currentTitle) {
                                    payload.updateTitle = {
                                        previousTitle: currentTitle,
                                        newTitle: questionTitle
                                    }
                                }

                                if (JSON.stringify(questionWithoutTitle) !== JSON.stringify(currentWithoutTitle)) {
                                    payload.isUpdateDetail = true
                                }

                                updatePayload.payload.questions.push(payload)
                            }
                        } else {
                            const exceptList = {
                                reveal_image: 'question_reveal',
                                scale_image: 'question_scale',
                                typing_question: 'question_type',
                                sorting_list: 'question_sorting'
                            }

                            const translateType = exceptList[question.question_type] || `question_${question.question_type}`

                            createPayload.payload.questions.push({
                                title: question.title,
                                translateType
                            })
                        }
                    }

                    if (createPayload.payload.questions.length) {
                        saveLogs(createPayload)
                    }

                    if (updatePayload.payload.questions.length) {
                        saveLogs(updatePayload)
                    }
                }

                if (action.payload.logMessage === 'clone') {
                    const clonePayload = {
                        quiz_id: state.question._id,
                        action: 'clone_question',
                        payload: {
                            questions: []
                        }
                    }

                    for (const question of action.payload.logQuestions) {
                        clonePayload.payload.questions.push({
                            title: question.title
                        })
                    }

                    saveLogs(clonePayload)
                }

                if (action.payload.logMessage === 'delete') {
                    const deletePayload = {
                        quiz_id: state.question._id,
                        action: 'delete_question',
                        payload: {
                            questions: []
                        }
                    }

                    for (const question of action.payload.logQuestions) {
                        deletePayload.payload.questions.push({
                            title: question.title
                        })
                    }

                    saveLogs(deletePayload)
                }

                break

            case 'updateShareSetting': {
                const payload = {
                    quiz_id: action.payload.id,
                    action: 'update_share_setting',
                    payload: {
                        previousCanRead: !action.payload.can_read,
                        newCanRead: action.payload.can_read,
                        previousCanEdit: !action.payload.can_edit,
                        newCanEdit: action.payload.can_edit,
                        previousCanAccessReport: !action.payload.can_access_report,
                        newCanAccessReport: action.payload.can_access_report
                    }
                }

                if (!action.payload.type) return

                if (action.payload.type === 'read') {
                    payload.payload.type = 'update_share_setting_read'
                }

                if (action.payload.type === 'edit') {
                    payload.payload.type = 'update_share_setting_edit'
                }

                if (action.payload.type === 'access_report') {
                    payload.payload.type = 'update_share_setting_access_report'
                }

                saveLogs(payload)

                break
            }

            default:
                break
        }
    });

    store.subscribe((mutation, state) => {
        if (['updateQuestion', 'setQuizStatus'].includes(mutation.type)) {
            quiz = JSON.parse(JSON.stringify(state.question))
        }

        if (mutation.type === 'updateQuizQuestions') {
            quiz.questions = JSON.parse(JSON.stringify(state.question.questions))
        }
    })
}
